import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class TriggerService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/triggers`);
  }

  restoreDefault(id: string, urlParams?: any, apiParams?: any): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + `/${id}/default`;
    return this.http.put(url, {}, {
      params: this.toHttpParams({
        ...apiParams
      })
    });
  }

  copyFromCompany(
    payload: { source_company_id: string; trigger_ids: number[] },
    urlParams: any = {}
  ): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/triggers/copy_from`, urlParams);
    return this.http.post<any>(url, payload);
  }

  snapshot(urlParams: any = {}) {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/triggers/snapshot`, urlParams);
    return this.http.post<any>(url, {});
  }

  /** GET /companies/:companyId/triggers/custom_conditions — registered conditions from services/custom_conditions/index.js */
  listCustomConditions(urlParams: any = {}): Observable<{ key: string; name: string; description: string; triggering_actions: string[] }[]> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/triggers/custom_conditions`, urlParams);
    return this.http.get<{ key: string; name: string; description: string; triggering_actions: string[] }[]>(url);
  }
}
